export default {
    data() {
        return {
            // 传递过来的id
            id: null,
            // 通知还是指南
            type: '',
            // 获取的数据
            data: {},
            // 是否含有html标签
            isHTML: false
        }
    },
    methods: {
        // 点击下载附件
        downLoad() {
            // window.open(this.baseUrl + 'excel/czUpload.xlsx')
        },

        // exportData() {
        //     location.href = this.baseUrl + 'work/' + this.fileName;
        // },

        // exportData1(fileName) {
        //     location.href = this.baseUrl + 'work/' + fileName;
        // },

        // 根据type判断要调用的接口从后端获取数据
        getData() {
            let type = this.type
            if (type === 'notice') {
                this.$post('product_notices/notice', {
                    id: this.id
                }).then(res => {
                    this.data = res.data.result
                    this.judgeIsHTML(this.data.content)
                })
            } else if (type === 'news') {
                this.$post('product_news/news', {
                    id: this.id
                }).then(res => {
                    this.data = res.data.result
                    this.judgeIsHTML(this.data.content)
                })
            }
        },

        // 判断是否含有html标签
        judgeIsHTML(str) {
            var reg = /<[^>]+>/g;
            this.isHTML = reg.test(str)
        }
    },
    mounted() {
        this.id = this.$route.query.id
        this.type = this.$route.query.type
        this.getData()
    }
}